import View from './PageList'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const PageList = connect(mapStateToProps)(View)

export default PageList
